import styled from 'styled-components';

const ContentSectionItem = styled.div`
	padding-bottom: 4rem;
`;

export const Styled = {
	ContentSectionItem,
};
